/**
* トップページのコンストラクタ
* @constructor
*/
module.exports = TopPage = function(){
  this.state = $('.js-hamburger-state');
  this.win = $(window);
  this.device;
  this.checkDevice();
  this.resize();
  this.init();
};

/**
* initialize
*/
TopPage.prototype.init = function(){
  var self = this;

  this.event();

  // youtube iframe api
  if(typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined'){
    this.ytLoaded = this.getYTapi();
    this.ytLoaded.done(function(){
      // メインビジュアル
      self.initMv($('.js-youtube-bg'));
      // その他
      self.initPlayers();
      // SP
      $('.js-yt-control').on('click', function(e){
        e.preventDefault();
        var parent = $(this).closest('.js-yt');
        var embedId = parent.attr('data-embed-id');
        var videoId = parent.attr('data-video-id');
        if(self.device === 'sp') self.initModal(embedId, videoId);
      });
    });
  }else{
    // メインビジュアル
    this.initMv($('.js-youtube-bg'));
    // その他
    this.initPlayers();
    // SP
    $('.js-yt-control').on('click', function(e){
      e.preventDefault();
      var parent = $(this).closest('.js-yt');
      var embedId = parent.attr('data-embed-id');
      var videoId = parent.attr('data-video-id');
      if(self.device === 'sp') self.initModal(embedId, videoId);
    });
  }
};

/**
* イベント
*/
TopPage.prototype.event = function(){
  var self = this;

  // 画面サイズ
  this.headerHeight = $('.header').height();
  this.fixedHeight = $('.fixed').height();
  this.calcRatio(this.win.height() - this.fixedHeight);

};

/**
* 動画領域の計算
* @param {number} - h 起点とする高さ
*/
TopPage.prototype.calcRatio = function(h){
  var self = this;

  if(this.device === 'sp') return;

  // 動画領域
  $('.js-ratio').each(function(){
    // 領域
    var wrapper = h - self.headerHeight;

    // 領域に対する16:9の幅
    var width = wrapper * 16 / 9;
    // ブラウザ幅に対する16:9の高さ
    var height = self.win.width() * 9 / 16;

    if(height > wrapper){
      $(this).css({'width':width, 'height':wrapper});
      $('.p-top-outline-item').css({'width':width});
    }else{
      $(this).css({'width':'100%', 'height':height});
    }
  });

  // コンテンツ領域
  $('.js-section').each(function(i){
    var ht;
    if($(this).hasClass('mod-intro')){
      ht = self.win.height() - self.fixedHeight;
    }else{
      ht = $('.p-top-yt-embed.js-ratio').outerHeight();
    }
    $(this).css({
      'height': ht,
      'padding-bottom': 0
    });
  });
};

/**
* get youtube iframe API
*/
TopPage.prototype.getYTapi = function(){
  var defer = $.Deferred();
  $.getScript('//www.youtube.com/player_api', function(){
    window.onYouTubeIframeAPIReady = function() {
      defer.resolve();
    };
  });
  return defer.promise();
};

/**
* Mv設定
* @param {selector} - el jqueryセレクタ
*/
TopPage.prototype.initMv = function(el){
  var self = this;

  if(this.device === 'sp') return;

  this.mvEmbedId = el.attr('data-embed-id');
  this.mvVideoId = el.attr('data-video-id');

  player = new YT.Player(self.mvEmbedId, {
    videoId: self.mvVideoId,
    playerVars: {
      'autoplay': 1,
      'controls': 0,
      'enablejsapi': 1,
      'iv_load_policy': 3,
      'disablekb':1,
      'showinfo':0,
      'rel':0,
      'start': 0,
      'end': 98,
			'playsinline': 1,
      'modestbranding': 1
    },
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });

  function onPlayerReady(e){
    self.setSizeToMv(self.mvEmbedId);
    e.target.mute();
    e.target.playVideo();
//    e.target.mute();
  }

  function onPlayerStateChange(e){
    var status = e.target.getPlayerState();
    if(status == YT.PlayerState.ENDED){
      player.mute();
      player.playVideo();
//      player.mute();
    }
    if(status === 1){
      self.sns();
    }
  }

  self.checkDevice();
  if(self.device === 'pc'){
      this.win.on('mousemove', function(e){
        $('.p-top-mv-scroll').fadeIn(100);
      });
  }

};

/**
* Mv サイズ設定
* @param {string} - embedId iframe id
*/
TopPage.prototype.setSizeToMv = function(embedId){
  var bw = 1200;
  var bh = (bw / 16) * 9;
  var w = this.win.width();
  var h = this.win.height() - this.fixedHeight - this.headerHeight;
  var mw = w;
  var mh = Math.round(bh * (mw / bw));
   
  if(mh < h){
    mh = h;
    mw = Math.round(bw * (mh / bh));
  }
   
  $('#'+embedId).css({
    width: mw,
    height: mh,
    marginTop: (h - mh) / 2,
    marginLeft: (w - mw) / 2
  });
};

/**
* その他のプレイヤー設定
*/
TopPage.prototype.initPlayers = function(){
  var self = this;

  if(this.device === 'sp') return;

  // youtube 配列
  this.data = [];
  $('.js-yt').each(function(i){
    var obj = {};
    obj.embedId = $(this).attr('data-embed-id');
    obj.videoId = $(this).attr('data-video-id');
    self.data.push(obj);
  });

  var ytPlayer = [];
  var ytPlaying, ytStop, ytPlay;

  for(var i = 0; i < this.data.length; i++){
    ytPlayer[i] = new YT.Player(this.data[i].embedId, {
      videoId: this.data[i].videoId,
      playerVars: {
        modestbranding: 1,
        'showinfo': 0,
        'rel': 0
      },
      events: {
				'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
      }
    });
  }

  function onPlayerReady(e){
//    self.setSizeToMv(self.mvEmbedId);
//    e.target.mute();
//    e.target.playVideo();
//    e.target.mute();
  }

  function onPlayerStateChange(e){
    for(var i = 0; i < self.data.length; i++){
      var thisState = ytPlayer[i].getPlayerState();
      if (thisState == 1 && ytPlaying == undefined) {
        ytPlaying = i;
      } else if (thisState == 1 && ytPlaying != i) {
        ytStop = ytPlaying;
        ytPlay = i;
      } else {
      }
    }
    // 同時再生があった場合、元々再生していた方を停止する
    if(ytStop != undefined){
      ytPlayer[ytStop].pauseVideo();
      ytStop = undefined;
    }
    // 現在再生中のプレーヤー番号を保存しておく
    if(ytPlay != undefined){
      ytPlaying = ytPlay;
      ytPlay = undefined;
    }
  };

  function play(ytIndex, seekTime){
    var ytId = self.data[ytIndex]['videoId'];
    ytPlayer[ytIndex].loadVideoById(ytId);
  };

  // onclick
  $('.js-yt-control').on('click', function(e){
    e.preventDefault();
    var parent = $(this).closest('.js-yt');
    var embedId = parent.attr('data-embed-id');
    var videoId = parent.attr('data-video-id');
    var num = embedId.replace(/[^0-9^\.]/g,"");
    $(this).closest('.js-yt').addClass('is-clicked');
    play(num, 0);
    ga('send', {'hitType': 'event','eventCategory': 'YTPlayer','eventAction': 'play','eventLabel': videoId});
  });
};

/**
* モーダル設定
* @param {string} - embedID iframeに付与されるID
* @param {string} - videoID YoutubeID
*/
TopPage.prototype.initModal = function(embedID, videoID){
  var self = this;

  var embedID = embedID + '_sp';

  if(!$('.js-modal').length){
    var html = '';
    html += '<div class="modal js-modal">';
    html += '<div class="modal-iframe js-modal-content">';
    html += '<a href="#" class="modal-close c-bt js-modal-close"><span>閉じる</span></a>';
    html += '</div>';
    $('body').append('<div class="modal-overlay js-modal-overlay" />').append(html);
  };

  this.modal = $('.js-modal');
  this.modalOverlay = $('.js-modal-overlay');
  this.modalCloses = $('.js-modal-close, .js-modal-overlay');
  this.modalHtml = $('.js-modal-content');
  this.modalEmbed = $('.js-modal-embed');

  this.top = this.win.scrollTop();
  this.setModalPosition(this.top);
  this.modalOverlay.addClass('is-active');
  this.modal.addClass('is-active');

  if(!this.modalEmbed.length){
    this.modalHtml.prepend('<div class="js-modal-embed" id="' + embedID + '">');
  }

  window.myPlayer = new YT.Player(embedID, {
    videoId: videoID,
    playerVars: {
      modestbranding: 1,
			playsinline: 1,
      rel: 0,
      showinfo: 0,
      autoplay: 1
    },
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });


  function onPlayerReady(e){
//    self.setSizeToMv(self.mvEmbedId);
    e.target.mute();
//    e.target.playVideo();
//    e.target.mute();
  }

  this.modalOverlay.on('click',function(){
    self.removeModal();
    return false;
  });

  this.modal.on('click','.js-modal-close',function(){
    self.removeModal();
    return false;
  });
};

/**
* モーダル閉じる
*/
TopPage.prototype.removeModal = function(){
  this.modalOverlay.removeClass('is-active');
  this.modal.removeClass('is-active');
  this.modalHtml.children('iframe').remove();
}

/**
* モーダル位置調整
* @param {number} - _t ScrollTop
*/
TopPage.prototype.setModalPosition = function(_t){
  this.modal.css({
    'top': _t + this.win.height() / 2 - this.modal.height() / 2
  });
}

/**
* ゼロパディング
* @param {array}
* @return {string}
*/
TopPage.prototype.zeroPadding = function(array){
  var num = [];
  for(var i = 0; i < array.length; i++){
    num.push(('0' + array[i]).substr(-2));
  }
  return num;
};

/**
* リサイズ
*/
TopPage.prototype.resize = function(){
  var self = this;
  var timer = false;
  this.win.on('resize', function(){
    if(timer !== false){
      clearTimeout(timer);
    }
    timer = setTimeout(function(){
      self.checkDevice();
      if(self.device === 'pc'){
        self.calcRatio(self.win.height() - self.fixedHeight);
        self.setSizeToMv(self.mvEmbedId);
      }else{
        $('.js-section, .js-ratio, .p-top-mv').removeAttr('style');
      }
    },400);
  });

};

/**
* デバイスチェック
*/
TopPage.prototype.checkDevice = function(){
  var isSP = this.state.is(':visible');
  if(isSP){
    this.device = 'sp';
  }else{
    this.device = 'pc';
  }
};

/**
* Twitter
*/
TopPage.prototype.sns = function(){
  var facebook = '<div id="fb-root"></div><script>(function(d, s, id) {var js, fjs = d.getElementsByTagName(s)[0];if (d.getElementById(id)) return;js = d.createElement(s); js.id = id;js.src = "//connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v2.8&appId=986703674807672";fjs.parentNode.insertBefore(js, fjs);}(document, "script", "facebook-jssdk"));<\/script>';
  var twitter = '<script>!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?"http":"https";if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+"://platform.twitter.com/widgets.js";fjs.parentNode.insertBefore(js,fjs);}}(document, "script", "twitter-wjs");<\/script>';
  $('body').append(facebook + twitter);
}

/**
* add_200301
*/
$(function(){
	$('.top-rice-list__item').hover(
		function() {
			var thisSerif = $(this).find('.top-rice-list__serif').html();
			$('#chara-serif').html(thisSerif).addClass('active');
		}, function() {
			$('#chara-serif').removeClass('active');
		}
	);
});



//////////////////
// WEBPACK FOOTER
// ./js/_modules/topPage1.js
// module id = 6
// module chunks = 0